import script from "./FileGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./FileGroup.vue?vue&type=script&setup=true&lang=js"

import "./FileGroup.vue?vue&type=style&index=0&id=7eb60a6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eb60a6a"]])

export default __exports__